export default function parseModel(data) {
  if (!data) return {};
  if (typeof data !== "object") return {};
  return JSON.parse(JSON.stringify(data));
}
